<template>
  <div class="retailOrderSubmit" >
    <div class="pageContent">
      <XR-head titleText="订单确认" :rightShow="true" ref="headObj"></XR-head>
       
      <template v-for="shopItem in productShowList"> 
        <div class="shopRow" :key="shopItem.ShopId">          
          <!-- <div class="all-chk"><mu-checkbox class="cart-all-chk" :nativeValue="cartItem.ShopId" @change="shopClick(cartItem.ShopId)" uncheckIcon=":fa fa-circle-thin" checkedIcon=":fa fa-yes"/></div> -->
          <div class="shopName">
            <span>{{shopItem.ShopName}}</span>
            <i class="fa fa-angle-right"></i>
          </div>      
        </div>    
        <div class="pro-list" :key="shopItem.ShopId">
          <div class="pro-item"  v-for="pItem in shopItem.Products" :key="pItem.SkuId">  
            <div class="pro-img">
              <img :src="pItem.DefaultImg?pItem.DefaultImg:IMGServer_URL+'/images/index-item-default.png'" />
            </div>
            <div class="pro-info" :style="{width:cartItemProductInfoWidth+'px'}">
              <p class="pro-name">{{pItem.Name}}</p>
              <p class="pro-attr">
                <template v-for="attrItem in pItem.Attrs">
                  {{attrItem.AttrName +":" + attrItem.AttrValue}} 
                </template>
              </p>
              <div class="pro-num">
                <p class="pro-price">              
                  <template v-if="pItem.State==0">
                    <i class="fa fa-rmb"></i>{{pItem.SalePrice.toFixed(2)}}
                  </template>
                  <template v-else>
                    商品已下架
                  </template>
                </p>
                <div class="count">x {{getCartItemCount(pItem.SkuId)}}</div>
              </div>
            </div>
          </div>
        </div>      
      </template>
      <div class="choose-info delivery"  @click="open('delivery')">
        <div class="info left">
          <div class="choose-row title">选择配送</div>
        </div>    
        <div :class="'goIcon '+(shippingMethodInfo.id!=3?'wuliu':'')">
          <i class="fa fa-angle-right"></i>
        </div> 
        <div class="info center" >
           <div class="choose-row">{{shippingMethodName}}</div>   
          <div class="choose-row" v-if="shippingDateName">{{shippingDateName}}</div>        
        </div>
        <mu-popup position="bottom" popupClass="retailOrderSubmit-popupLayer delivery" :open="deliveryPopup" @close="close('delivery')">
          <mu-sub-header >请选择送货方式</mu-sub-header>
          <div class="deliveryChoose">
            <template v-for="methodItem in shippingMethodList" v-if="!IsZiti">
              <mu-raised-button :label="methodItem.method"  :class="shippingMethodInfo.id==methodItem.Id?'shippingBtn select':''" @click="selectShippingMethod(methodItem.Id,methodItem.method)"></mu-raised-button>
            </template>
            <mu-raised-button label="自提" :class="shippingMethodInfo.id==3?'shippingBtn select':''" @click="selectShippingMethod(3,'自提')" v-if="IsZiti"></mu-raised-button>
          </div>
          <template v-if="!IsZiti">  
            <mu-sub-header >请选择送货时间</mu-sub-header>
            <div class="deliveryChoose">
              <template v-for="dateItem in shippingDateList" >
                <mu-raised-button  :label="dateItem.method" :class="shippingDateInfo.id==dateItem.Id?'shippingBtn select':''" @click="selectShippingDate(dateItem.Id,dateItem.method)"></mu-raised-button>
              </template>
            </div>            
          </template>
          <mu-raised-button primary @click="choseDelivery(1)" fullWidth class="delvieryChooseBtn" label="确定"/>
        </mu-popup>
      </div>
      <div class="choose-info delivery"  @click="goSelectSelfPickUp"  v-if="shippingMethodInfo.id == 3 && (IsZiti)">
        <div class="info left">
          <div class="choose-row title">选择自提点</div>
        </div>    
        <div class="goIcon selfPick">
          <i class="fa fa-angle-right"></i>
        </div> 
        <div class="info center" > 
          <div class="choose-row" v-if="selfPickUpShopInfo.shopName">{{selfPickUpShopInfo.shopName.length>15?selfPickUpShopInfo.shopName.substr(0,15):selfPickUpShopInfo.shopName}}</div> 
          <div class="choose-row" v-if="selfPickUpShopInfo.address">{{selfPickUpShopInfo.address.length>15?selfPickUpShopInfo.address.substr(0,15):selfPickUpShopInfo.address}}</div>           
        </div>
      </div>
      <div class="choose-info delivery"  @click="open('bottom')"  v-if="shippingMethodInfo.id == 3">
        <div class="info left">
          <div class="choose-row title">选择时间</div>
        </div>    
        <div class="goIcon">
          <i class="fa fa-angle-right"></i>
        </div> 
        <div class="info center" > 
          <div class="choose-row">{{orderInfo.selfPickUpDate}}</div>        
        </div>
        <mu-popup position="bottom" popupClass="retailOrderSubmit-popupLayer bottom"  :open="bottomPopup" @close="close('bottom')">
          <mu-sub-header >请选择自提时间</mu-sub-header>
          <div class="dateChoose" >
            <div class="dateleft">
                <mu-raised-button :class="selfPickUpDate1 == day?'active':''" @click="selectPickUpDate1(day)" :label="day" v-for="day in selfPickUpDateList" :key="day"></mu-raised-button>
            </div>
            <div class="daterigth">
                 <mu-raised-button label="上午" :class="selfPickUpDate2 == '上午'?'active':''" @click="selectPickUpDate2('上午')" ></mu-raised-button>
                <mu-raised-button label="下午" :class="selfPickUpDate2 == '下午'?'active':''" @click="selectPickUpDate2('下午')"  ></mu-raised-button>
            </div>
          </div>
          <mu-raised-button primary @click="choseDelivery(2)" fullWidth class="delvieryChooseBtn" label="确定"/>
        </mu-popup>
      </div>
      
      <div class="remark" style="padding-bottom:14px;"  v-if="shippingMethodInfo.id == 3 && orderInfo.addrId == 0">
        <mu-text-field label="联系电话" hintText="请输入联系电话" v-model="orderInfo.mobile" fullWidth helpText="方便商家联系" type="number"/>
      </div>

      <router-link to="/usercenter/address?redirecturl=/usercenter/address">
        <div class="receive-address" v-if="shippingMethodInfo.id != 3 ">  
          <span style="width:100%;line-height: 40px;font-weight: bold;" v-if="orderInfo.addrId ==0">请选择收货地址</span>            
          <div v-if="orderInfo.addrId !=0" class="mapIcon">
            <i class="fa fa-location"></i>
          </div>
          <div v-if="orderInfo.addrId !=0" class="address-info" :style="{width:addressInfoWidth+'px'}">
            <div class="contract">
              <span class="name">{{receiveAddress.Receiver}}</span>
              <span class="mobile">{{receiveAddress.Phone}}</span>
            </div>
            <div class="address-content">
              <span class="text">{{receiveAddress.DetailAddress}}</span>
            </div>
          </div>
          <div class="goIcon">
            <i class="fa fa-angle-right"></i>
          </div>
        </div>
      </router-link>

      <div class="choose-info">
        <div class="info left">
          <div class="choose-row title">发票</div>
        </div>   
        <div class="info center" :style="{width:chooseInfoWidth+'px'}">
          <div class="choose-row"><mu-switch v-model="isFapiao" /></div>
          <div class="choose-row">{{orderInfo.invoiceHead ? '抬头：'+orderInfo.invoiceHead:''}}</div>
        </div>
        <mu-popup position="bottom" popupClass="retailOrderSubmit-popupLayer fapiao" :open="fapiaoPopup" @close="close('fapiao')">
          <div class="deliveryChoose">
            <mu-text-field fullWidth label="发票抬头" hintText="请输入发票抬头" helpText="抬头不能超过25个汉字" v-model="orderInfo.invoiceHead" :maxLength="25" />
          </div>
          <mu-raised-button primary @click="closeChoose('fapiao')" fullWidth class="delvieryChooseBtn" label="确定"/>
        </mu-popup>
      </div>

      <div class="remark">
        <mu-text-field label="留言" hintText="最长不超过50个字符" v-model="orderInfo.remark" fullWidth multiLine :rows="1" :rowsMax="6" helpText="选填:给商家留言" :errorText="multiLineInputErrorText" @textOverflow="handleMultiLineOverflow" :maxLength="50"/>
      </div>

      <div class="price-info">
        <div class="row">
          <p class="title">商品金额</p>
          <p class="price">
            <i class="fa fa-rmb"></i>
            <span>{{totalPrice.toFixed(2)}}</span>
          </p>
        </div>
        <div class="row">
          <p class="title">运费</p>
          <p class="price">
            <span>+</span>
            <i class="fa fa-rmb"></i>
            <span>{{freightPrice}}</span>
          </p>
        </div>
      </div>

      <mu-divider />
      <div class="bottom-bar">
        <mu-row >
          <mu-col width="65" tablet="65" desktop="65">
            <p class="cart-total">
              <span>实付款：<i class="fa fa-rmb"></i></span>
              <span class="money">{{(totalPayPrice).toFixed(2)}}</span>
            </p>
          </mu-col>
          <mu-col width="35" tablet="35" desktop="35">
            <mu-flat-button label="提交订单" class="gobuy" backgroundColor="red" color="white" fullWidth @click="orderSubmit" />
          </mu-col>
        </mu-row>
      </div>
    </div>
    <XR-toast @onClose="submitSuccess" ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
import cart from '../../util/purchaseCart'
export default {
  data () {
    return {
      fullWidth: (parseInt(document.documentElement.clientWidth)-20) ,
      cartItemProductInfoWidth: (parseInt(document.documentElement.clientWidth)-130),
      addressInfoWidth: (parseInt(document.documentElement.clientWidth)-70) ,
      chooseInfoWidth: (parseInt(document.documentElement.clientWidth)-190) ,      
      deliveryPopup: false,
      fapiaoPopup: false,
      isFapiao: false,
      productInfoList:[],
      receiveAddress :{},
      totalPrice : 0,
      totalPayPrice : 0,
      shippingMethodInfo:{id:0,name:''},
      shippingDateInfo:{id:0,name:''},
      shippingMethodName:'',
      shippingDateName:'',
      orderInfo:{
        twoOrderType:0,
        invoiceHead:'',
        mobile:'',
        remark:'',
        productList:[],
        addrId:0,
        shippingMethodId:0,
        shippingDateId:0,
        selfPickUpSiteShopId:'',
        selfPickUpDate:'',
      },
      bottomPopup: false,
      shippingMethodList:[],
      shippingDateList:[],
      orderNos:[],
      submitTypeId:0,
      freightPrice: 0,      
      multiLineInputErrorText:'',
      skuId:this.$route.query.skuId,
      skuCount:this.$route.query.count? parseInt(this.$route.query.count):1,
      selfPickUpShopInfo:{},
      selfPickUpDateList:[],
      selfPickUpDate1:'',
      selfPickUpDate2:'',
      IsZiti:false,
      shopInfo:{},
      loaded:false,
      productShowList:[]
    }
  },
  mounted:function(){
    this.$refs.XRtoast.load()
      
    var dateObj = new Date()
    for(var i = 0; i<5; i++){
      dateObj.setDate(dateObj.getDate()+i)

      var year = dateObj.getFullYear()
      var month = dateObj.getMonth()+1
      if(month<10){
        month= '0'+month
      }
      var day = dateObj.getDate()
      if(day<10){
        day= '0'+day
      }
      day = year +'-'+ month +'-' + day
      this.selfPickUpDateList.push(day)
    }

    this.getDefaultAddress()
    this.getProductList()
    this.getShippingDateList()
    this.getShippingMethodList()
  },
  methods: {
    open (obj) {
      this[obj+'Popup'] = true
      if(obj == 'delivery'){
        this.shippingMethodInfo.id = this.orderInfo.shippingMethodId
        this.shippingMethodInfo.name = this.shippingMethodName
        this.shippingDateInfo.id = this.orderInfo.shippingDateId
        this.shippingDateInfo.name = this.shippingDateName
      }
      else if(obj == 'fapiao'){
      }
    },
    close (obj) {
      this[obj+'Popup'] = false
      if(obj == 'fapiao'){
        this.isFapiao = false
      }      
    },
    closeChoose(obj){
      if(obj == 'fapiao'){
        if(!this.orderInfo.invoiceHead){
          this.isFapiao = false
        }
      }
      this[obj+'Popup'] = false
    },    
    handleMultiLineOverflow (isOverflow) {
      this.multiLineInputErrorText = isOverflow ? '不能超过50个字符' : ''
    },
    getDefaultAddress(){
      var ths = this
      ths.$post(
        "/Shop/UserServer/GetDefaultReceiveAddress"
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{      
          ths.$refs.XRtoast.hide()
          ths.receiveAddress = res.Data
          ths.orderInfo.addrId = res.Data.Id
          ths.loaded = false
        }
      });
    },
    getFreight(){
      var ths = this
      ths.$post(
        "/Shop/PurchaseServer/GetFreightByAddressCode",
        JSON.stringify({
          provinceCode:this.receiveAddress.Province,
          cityCode: this.receiveAddress.City,
          areaCode: this.receiveAddress.Area,
          shoppingMethod: this.orderInfo.shippingMethodId,
          skus: this.orderInfo.productList
        })
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{  
          ths.$refs.XRtoast.hide()
          ths.loaded = false
          ths.freightPrice = res.Data
          ths.totalPayPrice = ths.totalPrice + ths.freightPrice; 
        }
      });
    },
    getProductList(){
      var ths = this
      this.orderInfo.productList = []
      if(this.skuId>0){
        this.orderInfo.productList = [{skuId: this.skuId, count:this.skuCount}]
      }
      else{
        this.orderInfo.productList = cart.getSelectList()
      }
      if(this.orderInfo.productList.length ==0){
        return
      }
      var data = {skuIds:[]}
      for(var i =0; i< this.orderInfo.productList.length ; i++){        
        data.skuIds.push(this.orderInfo.productList[i].skuId)
      }
      if(data.skuIds.length ==0){
        return
      }

      ths.$post(
        "/Shop/PurchaseServer/GetCartProductList",
        JSON.stringify(data)
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{  
          ths.productShowList = res.Data
          for(var i=0; i< res.Data.length;i++){
            for(var j =0 ; j< res.Data[i].Products.length;j++){    
              if(res.Data[i].Products[j].State!=0){
                continue;
              }        

              ths.IsZiti = res.Data[i].IsZiti
              if(ths.IsZiti){
                ths.getSelectSelfPickUpCache()
              }


              ths.shopInfo = {shopId:res.Data[i].ShopId,shopName:res.Data[i].ShopName, address:res.Data[i].ShopAddress}


              ths.productInfoList.push(res.Data[i].Products[j])
              var count = ths.getCartItemCount(res.Data[i].Products[j].SkuId)
              if(ths.skuId>0){
                count=ths.skuCount
              }

              ths.totalPrice += res.Data[i].Products[j].SalePrice * count
            }
          }
          ths.totalPayPrice = ths.totalPrice + ths.freightPrice; 
          ths.$refs.XRtoast.hide()
          ths.loaded = false
        }
      });
    },    
    getShippingDateList(){    
      
      var ths = this  
      ths.$post(
        "/Shop/RetailServer/GetShippingDateList"
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.shippingDateList = res.Data
          ths.$refs.XRtoast.hide()
          ths.loaded = false
        }
      });
    },
    getShippingMethodList(){   
      var ths = this 
      ths.$post(
        "/Shop/RetailServer/GetShippingMethodList"
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{  
          ths.shippingMethodList = res.Data
          ths.$refs.XRtoast.hide()
          ths.loaded = false
        }
      });
    },
    getCartItemCount: function(skuId){
      var cartList = cart.getSelectList()
      if(this.skuId>0){
        cartList = [{skuId:skuId,count:this.skuCount}]
      }

      for(var i=0;i< cartList.length;i++){
        if(cartList[i].skuId == skuId){          
          return cartList[i].count
        }
      }
    },
    selectShippingDate(id, name){
      this.shippingDateInfo.id = id
      this.shippingDateInfo.name = name
    },
    selectShippingMethod(id, name){
      if(id==3){
        if(!(this.skuId>0)){
          this.close('delivery')
          this.$refs.XRtoast.failed('只支持单品自提', true)
          return
        }
      }

      this.shippingMethodInfo.id = id
      this.shippingMethodInfo.name = name
    },
    selectPickUpDate1(day){
      this.selfPickUpDate1= day
    },
    selectPickUpDate2(part){
      this.selfPickUpDate2 = part
    },
    choseDelivery(type){
      if(type == 1){
        this.close('delivery')  

        if(this.shippingMethodInfo.id<=0){
          this.$refs.XRtoast.failed('请选择送货方式', true)
          return
        }
      
        this.orderInfo.shippingMethodId = this.shippingMethodInfo.id
        this.shippingMethodName = this.shippingMethodInfo.name
              
        if(this.orderInfo.shippingMethodId==3){
          if(!(this.skuId>0)){
            this.$refs.XRtoast.failed('只支持单品自提', true)
            return
          }
          
          if(this.IsZiti){          
            this.goSelectSelfPickUp()
          }
          else if(this.isZiTiService){
            this.selfPickUpShopInfo = this.shopInfo
            this.orderInfo.selfPickUpSiteShopId= this.shopInfo.shopId
          }
          else{
            this.$refs.XRtoast.failed('商品不支持自提', true)
            return          
          }        
        }else{     
          if(this.shippingDateInfo.id<=0){
            this.$refs.XRtoast.failed('请选择送货时间', true)
            return
          }     
          this.orderInfo.shippingDateId = this.shippingDateInfo.id
          this.shippingDateName = this.shippingDateInfo.name
        }

        this.getFreight()
      }else{
        this.close('bottom')
        this.orderInfo.selfPickUpDate = this.selfPickUpDate1+' '+this.selfPickUpDate2
      }
    },
    getSelectSelfPickUpCache(){      
      var cacheSelfPickUp = window.localStorage.PurchaseSelfPickUpShopInfo
      if(cacheSelfPickUp){
        this.selfPickUpShopInfo = JSON.parse(cacheSelfPickUp)    
        this.orderInfo.selfPickUpSiteShopId = this.selfPickUpShopInfo.shopId  
                
        this.orderInfo.shippingMethodId = 3
        this.shippingMethodInfo.id =3
        this.shippingMethodInfo.name = '自提'
        
        this.shippingMethodName = this.shippingMethodInfo.name
      }
    },
    goSelectSelfPickUp(){
      if(this.IsZiti){
        this.$router.push('/wholesale/selectSelfPickUp?skuId='+this.skuId)
      }else{
        this.$refs.XRtoast.failed("该商品不支持其他自提点", true)
        return
      }
    },
    orderSubmit(){
      if(this.orderInfo.shippingMethodId==0){
        this.$refs.XRtoast.failed("请选择配送方式", true)
        return
      }
      if(this.orderInfo.shippingMethodId == 3){
        if(!this.orderInfo.selfPickUpDate){
          this.$refs.XRtoast.failed("请选择自提时间", true)
          return
        }
        if(!this.orderInfo.selfPickUpSiteShopId){
          this.$refs.XRtoast.failed("请选择自提时间", true)
          return          
        }
        if(!this.orderInfo.mobile && this.orderInfo.addrId == 0){
          this.$refs.XRtoast.failed("请输入联系电话", true)
          return          
        }
      }else{        
        if(this.orderInfo.addrId ==0){
          this.$refs.XRtoast.failed("请选择收货地址", true)
          return
        }
        if(this.orderInfo.shippingDateId==0){
          this.$refs.XRtoast.failed("请选择配送时间", true)
          return
        }
      }

      var ths = this
      ths.$post(
        "/Shop/PurchaseServer/OrderSubmit",
        JSON.stringify(this.orderInfo)
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{      
          window.localStorage.removeItem('SelfPickUpShopInfo') 
          ths.orderNos = res.Data
          ths.submitTypeId = res.TypeId
          cart.clearSelectList()
          ths.$refs.XRtoast.success(res.Msg, true)

        }
      });
    },
    submitSuccess(){
      if(this.submitTypeId==1){
        this.$router.push('/wholesale/orderPaySuccess')
      }else{
        this.$router.push('/wholesale/orderPay?orderNo='+this.orderNos.join(','))
      }
    }
  },
  watch :{
    isFapiao:function(){
      if(this.isFapiao){
        this.open('fapiao')
      }else{
        this.orderInfo.invoiceHead=''
      }
    }
  }
}
</script>
<style>
.retailOrderSubmit{
  background: #F0F2F5;
  bottom: unset;
}
.pageContent{
  padding-bottom: 56px;
}

.retailOrderSubmit .goIcon{
  width: 20px;
  float: right;
  text-align: right;
}
.retailOrderSubmit .goIcon.wuliu{
  line-height: 48px;
}
.retailOrderSubmit .goIcon.selfPick{
  line-height: 48px;
}

.retailOrderSubmit .mapIcon{
  float: left;
  width: 30px;
  line-height: 40px;
}

.retailOrderSubmit .receive-address{
  background: white;
  color:black;
  padding: 10px;
  overflow: hidden;
  margin-top: 10px;
}
.retailOrderSubmit .receive-address .address-info{
  float: left;
}
.retailOrderSubmit .receive-address .address-info .name{
  font-size:16px;
  font-weight: 700;
  padding-right: 15px;
}
.retailOrderSubmit .receive-address .address-info .mobile{
  font-size:16px;
  font-weight: 700;
}
.retailOrderSubmit .receive-address .address-info .address-content{
  font-size:12px;
  line-height: 18px;
  color:#999;
}
.retailOrderSubmit .receive-address .address-info .address-content .fa{
  width: 20px;
}
.retailOrderSubmit .receive-address .goIcon{
  line-height: 40px;
}

.retailOrderSubmit .choose-info{
  overflow: hidden;
  padding:10px;
  background: white;
  margin-top: 10px;
}
.retailOrderSubmit .choose-info .info{
  font-size: 12px;
  float: left;
  line-height: 24px;
}
.retailOrderSubmit .choose-info .info.center{
  float: right;
}
.retailOrderSubmit .choose-info .info.left {
 
}
.retailOrderSubmit .choose-info .info.left .title{
  font-size: 14px;
  font-weight: 700;
}
.retailOrderSubmit .choose-info .info .choose-row{
  line-height: 24px;
}
.retailOrderSubmit .choose-info .info.center .choose-row{
  text-align: right;
}
.retailOrderSubmit .choose-info.integral .info.left .choose-row.balance{
  color:red;
}
.retailOrderSubmit .choose-info.integral .info.center .choose-row.integralModify{
  color:red;
}
.retailOrderSubmit .info.center .choose-row.ziti{
  float: left;
}

.retailOrderSubmit .remark{
  background: white;
  margin-top: 10px;
  padding:10px 10px 0;
}

.retailOrderSubmit .price-info{
  background: white;
  margin-top: 10px;
  padding:10px 10px 40px;
}
.retailOrderSubmit .price-info .row{
  background: white;
  overflow: hidden;
  line-height: 32px;
}
.retailOrderSubmit .price-info .row .title{
  font-size: 14px;
  font-weight: 700;
}
.retailOrderSubmit .price-info .row .price{
  color:Red;
  font-weight: 700;
}


.retailOrderSubmit .shopRow{
  background: #F8F8F8;
  overflow: hidden;
  color:#666;
  width: 100%;
  line-height: 40px;
  height: 40px;
  border-top:#ddd solid 1px;
}
.retailOrderSubmit .shopRow .all-chk{
  float: left;
  width: 40px;
  margin-top: 6px;
  text-align: center;
}
.retailOrderSubmit .shopRow .shopName{
  padding-left: 10px;
}


.retailOrderSubmit .pro-list{
  background: white;
  overflow: hidden;
}
.retailOrderSubmit .pro-list .pro-item{
  padding: 16px 0;
  overflow: hidden;
}
.retailOrderSubmit .pro-list .pro-item .pro-img{
  width: 80px;
  float: left;
}
.retailOrderSubmit .pro-list .pro-item .pro-img img{
  width: 100%;
  display: block;
  border-radius: 4px;
  margin: 0 20px;
}
.retailOrderSubmit .pro-list .pro-item .pro-info{
  float: right;
  padding-right: 10px;
}
.retailOrderSubmit .pro-list .pro-item .pro-info .pro-name{
  font-size: 12px;
  line-height: 16px;
  height: 32px;
  padding-bottom: 4px;
  overflow: hidden;
}
.retailOrderSubmit .pro-list .pro-item .pro-info .pro-attr{
  font-size: 12px;
  line-height: 16px;
  height: 30px;
  color:#999;
}
.retailOrderSubmit .pro-list .pro-item .pro-info .pro-num{
  font-size: 12px;
  line-height: 16px;
  height: 16px;
  color:#999;
}
.retailOrderSubmit .pro-list .pro-item .pro-info .pro-num .pro-price{
  font-size: 16px;
  line-height: 16px;
  float: left;
  color:red;
}
.retailOrderSubmit .pro-list .pro-item .pro-info .pro-num .count{
  font-size: 12px;
  line-height: 16px;
  color:#999;
  float: right;
}




.retailOrderSubmit .bottom-bar{
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  height: 56px;
  border-top:1px solid #eee;
  z-index: 9999;
}
.retailOrderSubmit .bottom-bar .cart-total{
  float: left;
  height: 56px;
  padding-left: 20px;
  font-size: 16px;
  font-weight: 700;
  color:Red;
}
.retailOrderSubmit .gobuy{
  width: 100%;
  line-height: 56px;
  height: 56px;
  text-align: center;
}

.retailOrderSubmit-popupLayer {
  width: 100%;
  min-height: 120px;
}
.retailOrderSubmit-popupLayer .deliveryChoose {
  padding: 0 10px;
}
.retailOrderSubmit-popupLayer .delvieryChooseBtn{
  margin: 40px 0 0;
  height: 50px; 
}

.retailOrderSubmit-popupLayer .shippingBtn.select{
  background: red;
  color:white;
}
.retailOrderSubmit-popupLayer .dateChoose{
  padding: 0 10px;
  display: flex;
}
.dateChoose .dateleft{
width: 50%;
}
.dateChoose .daterigth{
  width: 50%;
  text-align: right;
  text-align: -webkit-right;
}
.dateChoose .active{
  background: red;
  color:white;
}
.dateChoose .daterigth .mu-raised-button{
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/pages/wholesale/orderSubmit.vue